import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Text,
  VStack,
  useColorModeValue,
  Image} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { FiHome, FiArrowLeft } from 'react-icons/fi';

const NotFoundPage = () => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.700', 'white');
  
  return (
    <Box minH="100vh" bg={bgColor}>
      {/* Hero Section with Gradient Overlay */}
      <Box
        bgImage="linear-gradient(to right, rgba(255, 26, 61, 0.85), rgba(255, 94, 0, 0.85)), url('/assets/img/food.jpg')"
        bgSize="cover"
        bgPosition="center"
        height="30vh"
        position="relative"
        boxShadow="xl"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Heading color="white" fontSize={{ base: "4xl", md: "5xl" }} fontWeight="bold">
          404
        </Heading>
      </Box>

      <Container maxW="xl" py={12}>
        <VStack
          spacing={8}
          bg={bgColor}
          borderRadius="xl"
          boxShadow="xl"
          p={{ base: 6, md: 8 }}
          mt="-20"
          borderTop="4px solid"
          borderTopColor="brand.500"
          textAlign="center"
        >
          <VStack spacing={4}>
            <Heading size="xl" color={textColor}>
              Page Not Found
            </Heading>
            <Text color="gray.500" fontSize="lg">
              Oops! The page you&apos;re looking for doesn&apos;t exist or has been moved.
            </Text>
          </VStack>

          <Image 
            src="/assets/img/food-pattern.svg" 
            alt="Food pattern" 
            maxW="200px" 
            opacity="0.7" 
          />

          <Flex gap={4} flexWrap="wrap" justifyContent="center">
            <Button
              as={Link}
              to="/"
              colorScheme="brand"
              leftIcon={<FiHome />}
              size="lg"
            >
              Back to Home
            </Button>
            <Button
              as={Link}
              to="#"
              onClick={() => window.history.back()}
              variant="outline"
              leftIcon={<FiArrowLeft />}
              size="lg"
            >
              Go Back
            </Button>
          </Flex>
        </VStack>
      </Container>
    </Box>
  );
};

export default NotFoundPage;
